<div class="cim-field" [class.cim-field-fullwidth]="isFullWidth">
  <div class="cim-field-label">{{ label }}</div>
  <button
    [matMenuTriggerFor]="filtermenu"
    type="button"
    [style.min-width]="isFullWidth ? '100%' : '150px'"
    class="cim-field-control"
    [class.is-placeholder]="!selectedBenchmark"
  >
    <span class="cim-field-value">
      {{ selectedBenchmark ? selectedBenchmark.name_short : benchmarkPlaceholder }}
    </span>
    @if (selectedBenchmark) {
      <button
        type="button"
        mat-icon-button
        (click)="removeBenchmark(); $event.stopPropagation()"
        class="cim-field-clear"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
    <span class="cim-field-arrow" aria-hidden="true"></span>
  </button>
</div>
<mat-menu #filtermenu="matMenu" [overlapTrigger]="false" class="filter-menu">
  <div mat-menu-item [disableRipple]="true" style="height: 50px">
    <mat-form-field class="w-100" (click)="$event.stopPropagation()">
      <input
        placeholder="Search"
        matInput
        [(ngModel)]="searchText"
        class="select-input-search"
        (ngModelChange)="onSearchChange()"
      />
      @if (searchText != "") {
        <button
          mat-icon-button
          matSuffix
          color="primary"
          (click)="resetSearch()"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
  </div>

  <mat-accordion class="app-nav-accordion">
    @if (indices.length > 0) {
      <mat-expansion-panel>
        <mat-expansion-panel-header (click)="$event.stopPropagation()">
          <mat-panel-title><b>Equity Indices</b></mat-panel-title>
        </mat-expansion-panel-header>
        <mat-accordion class="app-nav-accordion">
          @for (panel of indices; track panel.group) {
            <mat-expansion-panel>
              <mat-expansion-panel-header (click)="$event.stopPropagation()">
                <mat-panel-title>{{ panel.group }}</mat-panel-title>
              </mat-expansion-panel-header>
              <mat-nav-list>
                @for (f of panel.items; track f.name) {
                  <div
                    mat-menu-item
                    (click)="onBenchmarkSelect(f)"
                    [class.active]="
                      selectedBenchmark && f.name === selectedBenchmark.name
                    "
                  >
                    {{ f.name_full }}
                  </div>
                }
              </mat-nav-list>
            </mat-expansion-panel>
          }
        </mat-accordion>
      </mat-expansion-panel>
    }

    <app-benchmark-category-panel
      title="Commodities"
      [items]="commodities"
      [selectedBenchmark]="selectedBenchmark"
      (benchmarkSelect)="onBenchmarkSelect($event)"
    />

    <app-benchmark-category-panel
      title="FX / Currencies"
      [items]="currencies"
      [selectedBenchmark]="selectedBenchmark"
      (benchmarkSelect)="onBenchmarkSelect($event)"
    />

    <app-benchmark-category-panel
      title="Rates"
      [items]="rates"
      [selectedBenchmark]="selectedBenchmark"
      (benchmarkSelect)="onBenchmarkSelect($event)"
    />

    <app-benchmark-category-panel
      title="Inflation"
      [items]="inflation"
      [selectedBenchmark]="selectedBenchmark"
      (benchmarkSelect)="onBenchmarkSelect($event)"
    />

    <app-benchmark-category-panel
      title="Growth"
      [items]="growth"
      [selectedBenchmark]="selectedBenchmark"
      (benchmarkSelect)="onBenchmarkSelect($event)"
    />

    <app-benchmark-category-panel
      title="Volatility"
      [items]="volatility"
      [selectedBenchmark]="selectedBenchmark"
      (benchmarkSelect)="onBenchmarkSelect($event)"
    />

    <app-benchmark-category-panel
      title="Financial Conditions"
      [items]="conditions"
      [selectedBenchmark]="selectedBenchmark"
      (benchmarkSelect)="onBenchmarkSelect($event)"
    />
  </mat-accordion>
</mat-menu>
